<div class="form-group calendar-width">
    <mat-calendar (selectedChange)="_onSelectedChange($event)"
        [selected]="selectedDateRange">
    </mat-calendar>
</div>
